import useLocalization from 'localization';
import React, { useMemo } from 'react';
import useTheme from 'branding/theme';
import useToggle from './useToggle';
const useLinkProps = (to, children, variant) => {
    const [isHovered, handleMouseEnter, handleMouseLeave] = useToggle();
    const [isFocused, handleFocus, handleBlur] = useToggle();
    const { t } = useLocalization();
    const { borders, colors } = useTheme();
    const childBody = typeof children === 'string' ? t(String(children)) : children;
    const finalChildBody = variant === 'secondary'
        ? React.createElement('span', {
            style: {
                ...borders.bottom,
                borderBottomColor: colors.neutrals.textBeta
            }
        }, childBody)
        : childBody;
    const isExternal = to.toString().includes('://');
    return useMemo(() => ({
        isHovered,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        isFocused,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: finalChildBody,
        ...(isExternal ? { href: to.toString(), target: '_blank' } : { to: to.toString() })
    }), [
        isFocused,
        handleFocus,
        handleBlur,
        isHovered,
        handleMouseEnter,
        handleMouseLeave,
        to,
        isExternal,
        finalChildBody
    ]);
};
export default useLinkProps;
//# sourceMappingURL=useLinkProps2.js.map